module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "maxlength": 12
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realname"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.realname),
      callback: function($$v) {
        _vm.$set(_vm.form, "realname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属组织架构",
      "prop": "structure_id"
    }
  }, [_c('el-select', {
    staticClass: "w-200",
    attrs: {
      "placeholder": "请选择组织架构"
    },
    model: {
      value: (_vm.form.structure_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "structure_id", $$v)
      },
      expression: "form.structure_id"
    }
  }, _vm._l((_vm.orgsOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位",
      "prop": "getAllselecct"
    }
  }, [_c('el-select', {
    staticClass: "w-200",
    attrs: {
      "placeholder": "请选择岗位"
    },
    model: {
      value: (_vm.form.post_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "post_id", $$v)
      },
      expression: "form.post_id"
    }
  }, _vm._l((_vm.getAllselect), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户组"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.selectedGroups),
      callback: function($$v) {
        _vm.selectedGroups = $$v
      },
      expression: "selectedGroups"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-checkbox', {
      staticClass: "form-checkbox",
      attrs: {
        "label": item.else
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c7e10e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/personnel/users/modifypwd.vue
// module id = 1866
// module chunks = 2